/**
 * RootLayout — replaces Next.js src/app/layout.tsx.
 *
 * Provides:
 *   - CartProvider (localStorage-backed cart state)
 *   - ShopNav (fixed header with cart count)
 *   - ShopFooter (links + legal)
 *   - <main> with pt-20 to clear the fixed nav
 *   - React Router <Outlet> for nested page rendering
 *   - ClientConsent (GDPR cookie banner + ConsentProvider + Sentry gate)
 *
 * This component is the root of the router tree (see src/router.tsx).
 * All page components render inside the <Outlet>.
 *
 * NOTE: ClientConsent was mounted in the legacy Next.js src/app/layout.tsx.
 * The Vite migration dropped it here, so shop.veterans.pro shipped without a
 * cookie-consent banner (GDPR Art. 7(1) gap; cookie-banner-runtime e2e red).
 * Re-mounting it at the router root restores the banner on every route.
 */

import { Outlet } from 'react-router'
import { CartProvider } from '@/components/CartProvider'
import { ShopNav } from '@/components/vite/ShopNav'
import { ShopFooter } from '@/components/vite/ShopFooter'
import { ClientConsent } from '@/components/ClientConsent'

export function RootLayout() {
  return (
    <CartProvider>
      <div className="min-h-screen bg-navy-deep text-white flex flex-col">
        <ShopNav />
        <main id="main-content" className="flex-1 pt-20">
          <Outlet />
        </main>
        <ShopFooter />
        <ClientConsent />
      </div>
    </CartProvider>
  )
}
